module.exports = __webpack_public_path__ + "img/2 - 2.90dc3bc4.png";